<template>
  <vue-apex-charts
    :width="heightPie"
    type="pie"
    :options="chartOptions"
    :series="data"
  ></vue-apex-charts>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "PieChart",
  components: {
    VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    colors: {
      type: Array,
      default: function () {
        return [];
      },
    },
    labels: {
      type: Array,
      default: function () {
        return null;
      },
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showLegend: {
      type: Boolean,
      default: false,
    },
    heightPie: {
      type: String,
      default: "100%",
    },
  },
  data() {
    return {};
  },
  computed: {
    chartOptions: function () {
      return {
        legend: {
          show: this.showLegend,
        },
        chart: {
          type: "pie",
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: this.showLabel,
        },
        labels: this.labels || this.colors,
        colors: this.colors,
      };
    },
  },
};
</script>

<style scoped></style>
